import { BaseClass } from "src/app/shared/classes/base";
import { Component, OnInit } from "@angular/core";
import { LoadingController, ModalController, NavParams, ToastController } from "@ionic/angular";
import { TranslationService } from "src/app/shared/services/translation.service";
import { ManagerEvaluationService } from "src/app/manager-evaluation/manager-evaluation.service";
import { PreviousEvaluationsInterface } from "src/app/manager-evaluation/_interfaces/previous-evaluations.interface";
import { QuestionAttributePipe } from "src/app/shared/pipes/question-attribute.pipe";
import { UtilService } from "src/app/shared/services/util.service";
import { QuestionTypeEnum } from "../../../shared/interfaces/process-config.interface";
import { AxiConfiguration } from "src/app/calibration/components/calibration-nine-box/models/axi.model";
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Component({
    selector: "app-previous-manager-evaluations-modal",
    templateUrl: "./previous-manager-evaluations.modal.html",
    styleUrls: ["./previous-manager-evaluations.modal.scss"],
})
export class PreviousManagerEvaluationsModal extends BaseClass implements OnInit {
    private _userId: string;
    private _cycleId: number;
    public userName: string;
    protected readonly QuestionTypeEnum = QuestionTypeEnum;
    public hideQuestionNumber: boolean;
    public hasInvertedQuadrants: boolean;
    public invertedQuadrants = [1, 4, 7, 2, 5, 8, 3, 6, 9];
    public previousEvaluations: Array<PreviousEvaluationsInterface>;
    public selectedEvaluation: PreviousEvaluationsInterface;
    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _modalController: ModalController,
        private _loadingController: LoadingController,
        private _navParams: NavParams,
        private _managerEvaluationService: ManagerEvaluationService,
        private _questionAttributePipe: QuestionAttributePipe,
        private _utilsService: UtilService,
        private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
        this._cycleId = parseInt(this._navParams.get("cycleId"), 10);
        this._userId = this._navParams.get("userId");
        this.userName = this._navParams.get("userName");
        
    }

    ngOnInit() {
        this.hideQuestionNumber = this._configService.settings.features.hideQuestionNumber;
        this.hasInvertedQuadrants = this._configService.settings.features.nineBox.invertedQuadrants;
        this._loadCycles();
    }

    private async _loadCycles() {
        const loading = await this._loadingController.create();
        await loading.present();

        this._managerEvaluationService.getPreviousEvaluations(this._cycleId, this._userId).subscribe(
            (response) => {
                loading.dismiss();
                this.previousEvaluations = response.data;
                if (this.previousEvaluations.length == 0 || this.previousEvaluations.every((evaluation) => evaluation.errorMessage != null)) {
                    this.notify(this._translationService.getTranslation("managerEvaluation.noPreviousEvaluations"), "danger");
                    this.dismiss();
                }
                this.previousEvaluations.forEach((evaluation) => {
                    evaluation.questionsGroups.forEach((group) => {
                        group.questions = this._utilsService.groupQuestions(group.questions);
                    });
                    evaluation.questionsGroups = evaluation.questionsGroups.filter((group) => {
                        return !group.questions.every((q) => q.typeConfig.type == QuestionTypeEnum.Calculate);
                    });
                });
            },
            (error) => {
                loading.dismiss();
                this.notify(this.getErrorNotification(error), "danger");
            },
        );
    }

    public async dismiss() {
        await this._modalController.dismiss();
    }

    public changeEvaluation(event: any) {
        this.selectedEvaluation = event.target.value;
    }

    public getQuestionAnswer(question: any, evaluation: any, skip: number = 0) {
        let answer;
        if (question.typeConfig.possibleValues.length > 0) {
            let fieldValue = evaluation["field" + (question.order + skip)];
            if (!isNaN(fieldValue) && Number.isInteger(parseFloat(fieldValue))) fieldValue = (parseInt(fieldValue, 10) - 1).toString();
            answer = this.getText(question.typeConfig.possibleValuesGlobalized, fieldValue);
        } else answer = evaluation["field" + (question.order + skip)];
        return answer != null && answer != "" ? answer : "-";
    }

    public getQuadrantNumber(row: number, column: number): number {
        return 1 + column + 3 * row;
    }
    public alertErrorMessage(message: string) {
        if (!message) return;
        this.notify(this._translationService.getTranslation(message), "danger");
    }
}
